import { useEffect, useState } from "react";

const POLL_MS = 30000;
let _lastFetch = 0;
let _lastStatus = null;

async function _fetchStatus() {
    try {
        const base = process.env.REACT_APP_BACKEND_URL || "";
        const r = await fetch(`${base}/api/v1/maintenance/status`);
        if (!r.ok) return null;
        return await r.json();
    } catch { return null; }
}

/**
 * Live-updating maintenance flag. Polls `/api/v1/maintenance/status` every
 * 30s so if a super_admin toggles maintenance ON while a doctor is browsing,
 * the doctor's session flips to the branded screen within one poll cycle.
 */
export default function useMaintenanceStatus() {
    const [status, setStatus] = useState(_lastStatus);
    useEffect(() => {
        let cancelled = false;
        const tick = async () => {
            const now = Date.now();
            if (now - _lastFetch < 4000 && _lastStatus) {
                setStatus(_lastStatus);
                return;
            }
            _lastFetch = now;
            const s = await _fetchStatus();
            if (cancelled) return;
            if (s) { _lastStatus = s; setStatus(s); }
        };
        tick();
        const t = setInterval(tick, POLL_MS);
        return () => { cancelled = true; clearInterval(t); };
    }, []);
    return status;
}
